import { useMemo, useState } from 'react'
// antd
import { Button, Modal } from 'antd';
import { FaCircleInfo } from "react-icons/fa6";
// helpers
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import axios from 'axios'
import { isUndefined } from '@uirouter/react'
import { useQuery } from 'react-query'
import ModalLocation from './ModalLocation';
import styles from './styles.module.scss'
import ModalLogInfo from './ModalLogInfo/ModalLogInfo';
import { actionTypeDict } from './ModalLogInfo/actionTypeDict';

const getLocation = async (ip) => {
  const { data } = await axios({
    url: `http://ip-api.com/json/${ip}?lang=es`,
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

const Cell: React.FC<{ record: any }> = ({ record }) => {
  const { ipAddress } = record as { ipAddress: string }
  const [locationPath, setPath] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);
  const metadata = useMemo(() => {
    let metadata = {}

    try {
      metadata = JSON.parse(get(record, "metadata", "{}"))
    } catch (e) {

    }
    return metadata
  }, [record])

  const showModal = () => {
    if (!isEmpty(`${get(locationPath, "lat", "")}`) && !isEmpty(`${get(locationPath, "lon", "")}`)) setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const { data } = useQuery(`LocationIp-${ipAddress}`, {
    queryFn: () => getLocation(ipAddress.split(":", 1)),
    onSuccess: (data) => setPath(data)
  })

  const props = {
    container: {
      className: styles.truncateCell,
      onClick: e => {
        e.stopPropagation()
      }
    },
  }

  const getPath = useMemo(() => {
    const action = get(record, "actionName", "")
    const event = get(record, "eventName", "")

    if (action === "LOG_IN") return "Acceso a la plataforma"
    if (event === "PAGE" && action === "VIEW") return `Vista de ${get(metadata, "page", "")}`
    if (get(metadata, "actionType", null) !== null) return actionTypeDict[get(metadata, "actionType", "null")]

    return ""
  }, [locationPath])

  const spanStyle = {
    display: 'inline-block',
    maxWidth: '85%',
    whiteSpace: 'nowrap' as 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }

  return (
    <div {...props.container} title={getPath}>
      <span style={spanStyle}>{getPath}</span>
      {get(metadata, "actionType", null) !== null && <Button type="link" onClick={showModal} icon={<FaCircleInfo />} shape="circle" />}
      {isModalOpen && <ModalLogInfo handleCancel={handleCancel} metadata={metadata} />}
    </div>
  )
}

const ActionCell: React.FC = (action: string, record) => {
  if (action === '' || !action) return null

  return <Cell record={record} key={get(record, "date", "null")} />
}

export default ActionCell
